import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { setErrors } from "../../../../../redux/slices/appSettingsSlice";
import { selectAllFormSettings } from "../../../../../redux/slices/formSettingsSlice";
import { selectReceiptTransaction } from "../../../../../redux/slices/receiptsSlice";
import RecurringSummaryCancelModalContent from "./RecurringSummaryCancelModalContent";

/**
 * @param {object} props
 * @param {boolean} props.loading
 * @param {Function} props.onClose
 * @param {Function} props.setLoading
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryCancelModalContent = ({
    loading,
    onClose,
    setLoading,
}) => {
    const dispatch = useDispatch();

    const { currency = {} } = useSelector(selectAllFormSettings);

    const transaction = useSelector(selectReceiptTransaction);
    const { recurring = {} } = transaction;
    const { amount = "", frequency_description = "", id = "" } = recurring;

    const formattedFrequencyAmount = currencyString(amount, currency);

    const modalDeclineButtonLabel = `No. Keep my ${formattedFrequencyAmount}/${frequency_description} gift!`;

    const recurringId = id;

    const handleSuccess = (response) => {
        if (response.data.success) {
            window.location.reload();
        }
    };

    const errorMessage = [
        "We're sorry, it looks like something went wrong. Please try again.",
    ];

    const handleError = () => dispatch(setErrors(errorMessage));

    const cancelModalContentProps = {
        handleError,
        handleSuccess,
        loading,
        modalDeclineButtonLabel,
        onClose,
        recurringId,
        setLoading,
    };

    return <RecurringSummaryCancelModalContent {...cancelModalContentProps} />;
};

export default ConnectedRecurringSummaryCancelModalContent;
